import React from 'react';
import logo from './logo.svg';
import './App.css';
import initialData from './data/initial-data';
import secondaryData from './data/secondary-data';
import Column from './column';
import HorizontalColumn from './horizontal-column';
import styled from 'styled-components/macro';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';

const Container = styled.div`
  display: flex;
`;

const Description = () => {
  return (
    <div css={`
      margin: 10px;
      width: 100%;
    `}>
      <p>
        Use mouse or keyboard (tab to initiate, space-bar + arrow-keys to move).
        This application balances natural physical interactions of lifting and placing items while maintaining UX and retains more digital interactions.
      </p>
    </div>
  )
}

class HorizontalList extends React.Component {
  state = secondaryData;
  onDragStart = (start) => {

    const homeIndex = this.state.columnOrder.indexOf(start.source.droppableId);
    this.setState({
      homeIndex
    })

  }
  onDragUpdate = update => {
  }

  onDragEnd = result => {
    this.setState({
      homeIndex: null
    })


    //TODO: reorder our columns;
    const {destination, source, draggableId} = result;
    if (!destination){
      return;
    }
    if (
      destination.droppableId === source.droppableId && 
      destination.index === source.index
    ) return;

    const startColumn = this.state.columns[source.droppableId];
    const finishColumn = this.state.columns[destination.droppableId];

    // Same Column
    if (startColumn == finishColumn) {
      const newTaskIds = Array.from(startColumn.taskIds);
      newTaskIds.splice(source.index, 1); // remove the source element
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...startColumn,
        taskIds : newTaskIds
      }

      const newState = {
        ...this.state,
        columns : {
          ...this.state.columns,
          [newColumn.id] : newColumn,
        }
      }

      this.setState(newState);
      return;
    }
    

    // Moving from one list to another
    const startTaskIds = Array.from(startColumn.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...startColumn,
      taskIds: startTaskIds,
    }

    const finishTaskIds = Array.from(finishColumn.taskIds);
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finishColumn,
      taskIds: finishTaskIds,
    }

    const newState = {
      ...this.state,
      columns: {
        ...this.state.columns,
        [newStart.id] : newStart,
        [newFinish.id]: newFinish,
      }
    }
    this.setState(newState);
  }


  render() {
    return (
        <DragDropContext
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
        >
          <Container>
          {this.state.columnOrder.map((columnId, index) => {
            const column = this.state.columns[columnId];
            const tasks = column.taskIds.map(taskId => this.state.tasks[taskId]);
            //const isDropDisabled = index < this.state.homeIndex;

            return <HorizontalColumn key={column.id} column={column} tasks={tasks} />
          })}
          </Container>
        </DragDropContext>
    )
  }

}

class App extends React.Component {
  state = initialData;
  onDragStart = (start) => {

    const homeIndex = this.state.columnOrder.indexOf(start.source.droppableId);
    this.setState({
      homeIndex
    })

    const p = document.createElement('p');
    p.setAttribute('id', 'action');
    p.innerHTML = 'drag';
    document.body.appendChild(p);
  }
  onDragUpdate = update => {
  }
  onDragEnd = result => {
    this.setState({
      homeIndex: null
    })



    const p = document.getElementById('action')
    p.innerHTML = 'done';
    setTimeout(() => {document.body.removeChild(p)}, 300)
    const {destination, source, draggableId, type} = result;

    if (type === 'column') {
      const newColumnOrder = Array.from(this.state.columnOrder);
      newColumnOrder.splice(source.index, 1);
      newColumnOrder.splice(destination.index, 0, draggableId);

      const newState = {
        ...this.state,
        columnOrder: newColumnOrder
      }
      this.setState(newState);
      return;
    
    }

    if (!destination){
      return;
    }
    if (
      destination.droppableId === source.droppableId && 
      destination.index === source.index
    ) return;

    const startColumn = this.state.columns[source.droppableId];
    const finishColumn = this.state.columns[destination.droppableId];

    // Same Column
    if (startColumn == finishColumn) {
      const newTaskIds = Array.from(startColumn.taskIds);
      newTaskIds.splice(source.index, 1); // remove the source element
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...startColumn,
        taskIds : newTaskIds
      }

      const newState = {
        ...this.state,
        columns : {
          ...this.state.columns,
          [newColumn.id] : newColumn,
        }
      }

      this.setState(newState);
      return;
    }
    

    // Moving from one list to another
    const startTaskIds = Array.from(startColumn.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...startColumn,
      taskIds: startTaskIds,
    }

    const finishTaskIds = Array.from(finishColumn.taskIds);
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finishColumn,
      taskIds: finishTaskIds,
    }

    const newState = {
      ...this.state,
      columns: {
        ...this.state.columns,
        [newStart.id] : newStart,
        [newFinish.id]: newFinish,
      }
    }
    this.setState(newState);
  }

  render() {
    //onDragEnd is the only required
    return (
      <>
      <Description/>
      <DragDropContext
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
      >
        <Droppable droppableId="all-columns" direction="horizontal" type="column">
          {(provided) => (
            <Container 
              {...provided.droppabeProps}
              ref={provided.innerRef}
            >
            {this.state.columnOrder.map((columnId, index) => {
              const column = this.state.columns[columnId];
              const tasks = column.taskIds.map(taskId => this.state.tasks[taskId]);
              //const isDropDisabled = index < this.state.homeIndex;

              return <Column key={column.id} column={column} tasks={tasks} index={index}/>
            })}
            </Container>
          )}
        </Droppable>
      </DragDropContext>
      <HorizontalList/>
      </>
    )
  }
}


export default App;
